import React, { Component } from "react";
import { Table, Button, Input, Switch, Modal, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import GrupoForm from '../components/GrupoForm';
import { getTemPermissao, getTipoUsuario } from "../utils/LoginManager";

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Search } = Input;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
  };

  componentDidMount() {
    getTipoUsuario().then(tipoUsuario => {
      this.setState({
        tipoUsuario,
      },
        this.getListaRegistros()
      );
    })
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ carregando: true, });
    const { busca, pagina, limite } = this.state;
    axios
      .get('/grupos', {
        params: {
          page: pagina,
          limite: limite,
          buscaDescricao: busca,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };




  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    let request;
    if (registro.grp_idf) { //editar      
      request = axios.put(`/grupos/update/${registro.grp_idf}`, registro);
    } else { // cadastrar
      request = axios.post(`/grupos/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Registro gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }


  onEditarClick = registro => {
    this.setState({ carregando: true });
    axios.get(`/grupos/show/${registro.grp_idf}`)
      .then(response => {
        const { data } = response;

        this.setState({
          formVisivel: true,
          registroSelecionado: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/grupos/delete/${registro.grp_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.grp_idf === registro.grp_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
          })
      }
    })
  };



  onBuscar = (texto) => {
    this.setState({
      busca: texto
    },
      this.getListaRegistros);
  };

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      registroSelecionado: {}
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }





  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Editar" placement="left">
          <Button className="botoesModalFormEditar" disabled={getTemPermissao('GruposPage', 'editar') ? false : true} size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
        </Tooltip>
        <Tooltip title="Excluir" placement="right">
          <Button className="botoesModalFormExcluir" disabled={getTemPermissao('GruposPage', 'excluir') ? false : true} size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
        </Tooltip>
      </ButtonGroup>
    );
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      total, pagina, limite, busca } = this.state;

    return (
      <div className="contentRoutesContainer">
        <div>
          <h2 className="tituloPage">Cadastro de Grupos</h2>
          <hr />
          <br />

          <div className="pageFiltro">
            {(!this.state.tipoUsuario) || (getTemPermissao('GruposPage', 'novo')) ? (
              <Button
                onClick={this.onAdicionarClick}
                className="pageFiltro-adicionar"
              >
                Adicionar
              </Button>
            ) : null}

            <Search
              placeholder="Buscar por Descrição"
              onSearch={this.onBuscar}
              enterButton
              className="pageFiltro-busca"
            />

            <GrupoForm
              visivel={formVisivel}
              onSalvarClick={this.onSalvarClick}
              onCancelarClick={this.onCancelarClick}
              carregando={salvando}
              registroSelecionado={registroSelecionado}
            />

          </div>

          <br />

          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            // scroll={{ x: 600 }}
            rowKey={(registro => registro.grp_idf)}
          >
            <Column
              key="grp_codigo"
              dataIndex="grp_codigo"
              title="Código"
              width={"20%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="grp_descricao"
              dataIndex="grp_descricao"
              title="Descrição"
              width={"70%"}
              align="left"
              className="listaCadastro"
            />
            {getTemPermissao('GruposPage', 'editar') || getTemPermissao('GruposPage', 'excluir') ? (
              <Column
                key="acoes"
                title="Ações"
                render={this.renderAcoes}
                width={"10%"}
                align="center"
                className="listaCadastro"
              />
            ) : null}
          </Table>
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/GruposPage.js